import { useState } from "react";

import { abortIvv } from "@/apis/IVVHelper";

export const IVV_ABORTED_KEY = "ABORT_IVV";

export const useIVVAbort = () => {
  const [ivvAborted, setIvvAbortState] = useState(
    JSON.parse(localStorage.getItem(IVV_ABORTED_KEY) ?? "false") as boolean
  );

  const abortIVV = () => {
    setIvvAbortState(true);
    localStorage.setItem(IVV_ABORTED_KEY, JSON.stringify(true));
    void abortIvv();
  };

  return {
    ivvAborted,
    abortIVV,
  };
};
